import { routes as api } from '@/plugins/api'
import { ActionHandler } from 'vuex'
import { NewAttendanceFormState } from './state'

export default {
  /** @type {ActionHandler<NewAttendanceFormState, any>} */
  getQuestion({ state }, questionKey) {
    return state.questions[questionKey] ?? null
  },

  /** @type {ActionHandler<NewAttendanceFormState, any>} */
  getParameter({ state }, parameter) {
    return state.parameters[parameter] ?? null
  },

  /** @type {ActionHandler<NewAttendanceFormState, any>} */
  getAnswer({ state }, questionKey) {
    return state.answers[questionKey] ?? null
  },

  /** @type {ActionHandler<NewAttendanceFormState, any>} */
  getExtraAnswer({ state }, name) {
    return state.extraAnswers[name] ?? null
  },

  /** @type {ActionHandler<NewAttendanceFormState, any>} */
  async saveAllAnswers({ state }) {
    await api.saveAttendanceAnswers(state.attendance.id, state.answers, state.parameters, state.extraAnswers)
  },
}
